/// <amd-module name="Repos/CommitsList/Components/CommitsPullRequestLink" />
import * as React from "react";
import { FPSLink } from "VSS/Features/PlatformUI/FPSLink";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Icon } from "VSSUI/Icon";
import { Tooltip } from "VSSUI/TooltipEx";

import { GitPullRequest } from "Repos/Common/Contracts/Git";
import { IReposRoutingService } from "Repos/Common/ReposRoutingService";

export interface ICommitsPullRequestLinkProps {
    projectName: string;
    pullRequest: GitPullRequest;
    repositoryName: string;
}

export class CommitsPullRequestLink extends VssComponent<ICommitsPullRequestLinkProps> {
    private reposRoutingService: IReposRoutingService;

    constructor(props: ICommitsPullRequestLinkProps, context: IVssComponentContext) {
        super(props);
        this.reposRoutingService = context.pageContext.getService<IReposRoutingService>("IReposRoutingService");
    }

    public render() {
        const { repositoryName, projectName } = this.props;
        const { pullRequestId, title } = this.props.pullRequest;
        const pullRequestLink = this.reposRoutingService.getPullRequestUrl(repositoryName, projectName, pullRequestId);

        return (
            <>
                <Icon className={"icon-margin"} iconName={"BranchPullRequest"} />
                <Tooltip text={title} overflowOnly>
                    <FPSLink
                        className="text-ellipsis bolt-table-link bolt-table-inline-link font-weight-semibold font-size-mm"
                        href={pullRequestLink}
                        removeUnderline={true}
                    >
                        {pullRequestId}
                    </FPSLink>
                </Tooltip>
            </>
        );
    }
}
